/**
* Clamps the value between the min and max parameters
*
* @param {Number} value The value
* @param {Number} min The floor
* @param {Number} max The roof
* @returns {Number} A number between the min and max arguments
*/
export default function clamp(value, min, max) {
    return value < min
    ? min
    : value > max
    ? max
    : value;
}